function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M34.1094 0L48.6819 8.25969L63.1212 16.75L63.2544 33.5L63.1212 50.25L48.6819 58.7403L34.1094 67L19.5369 58.7403L5.09752 50.25L4.96437 33.5L5.09752 16.75L19.5369 8.25969L34.1094 0Z",
  fill: "#1E075F"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M31 34.9375H30.9991C30.9991 34.17 31.0619 34.5234 27.0123 26.3279C26.185 24.654 23.8159 24.6507 22.9872 26.3279C18.9034 34.5936 19.0009 34.1942 19.0009 34.9375H19C19 37.0331 21.6864 38.7321 25 38.7321C28.3136 38.7321 31 37.0331 31 34.9375ZM25 27.3482L28.375 34.1786H21.625L25 27.3482ZM48.9991 34.9375C48.9991 34.17 49.0619 34.5234 45.0123 26.3279C44.185 24.654 41.8159 24.6507 40.9872 26.3279C36.9034 34.5936 37.0009 34.1942 37.0009 34.9375H37C37 37.0331 39.6864 38.7321 43 38.7321C46.3136 38.7321 49 37.0331 49 34.9375H48.9991ZM39.625 34.1786L43 27.3482L46.375 34.1786H39.625ZM43.75 40.25H35.5V26.2691C36.602 25.781 37.4294 24.7759 37.6745 23.5536H43.75C44.1644 23.5536 44.5 23.214 44.5 22.7946V21.2768C44.5 20.8575 44.1644 20.5179 43.75 20.5179H36.9831C36.2987 19.6015 35.223 19 34 19C32.777 19 31.7012 19.6015 31.0169 20.5179H24.25C23.8356 20.5179 23.5 20.8575 23.5 21.2768V22.7946C23.5 23.214 23.8356 23.5536 24.25 23.5536H30.3255C30.5706 24.7754 31.3975 25.781 32.5 26.2691V40.25H24.25C23.8356 40.25 23.5 40.5896 23.5 41.0089V42.5268C23.5 42.9461 23.8356 43.2857 24.25 43.2857H43.75C44.1644 43.2857 44.5 42.9461 44.5 42.5268V41.0089C44.5 40.5896 44.1644 40.25 43.75 40.25Z",
  fill: "white"
});

var SvgAppeal = function SvgAppeal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 68,
    height: 67,
    viewBox: "0 0 68 67",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAppeal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/appeal.1376a5dc.svg";
export { ForwardRef as ReactComponent };